import styled from 'styled-components'

const H3 = styled.h3`
  color: ${props => props.theme.colors.darkGray};
  font-weight: 600;
`

export default H3
